import { FC } from 'react';

import { IoIosInformationCircle } from 'react-icons/io';

import { SPACING } from '~/common/constants/spacing';

import { IFormLabelProps } from './types';
import { Container } from './styles';
import { Typography } from '../Typograph';

export const FormLabel: FC<IFormLabelProps> = ({
  label,
  sublabel = '',
  description = '',
  labelSize = 'medium',
  isDisabled = false,
  isRequired = false,
  hint = '',
}) => {
  return (
    <Container>
      <header>
        <Typography.Label
          size={labelSize}
          color={isDisabled ? 'neutral400' : 'neutral200'}
        >
          {label}
        </Typography.Label>

        {isRequired && (
          <Typography.Label size={labelSize} color="neutral900">
            *
          </Typography.Label>
        )}

        {sublabel && (
          <Typography.Paragraph
            size="small"
            color={isDisabled ? 'neutral400' : 'neutral200'}
          >
            {sublabel}
          </Typography.Paragraph>
        )}

        {!!hint && (
          <IoIosInformationCircle
            size={14}
            color={isDisabled ? 'neutral400' : 'neutral200'}
          />
        )}
      </header>

      <div>
        {!!description && (
          <Typography.Paragraph
            size="small"
            color={isDisabled ? 'neutral400' : 'neutral200'}
            style={{
              marginTop: SPACING._8,
            }}
          >
            {description}
          </Typography.Paragraph>
        )}
      </div>
    </Container>
  );
};
